import { useMediaQuery, useTheme } from '@mui/material';
import Logo from '../../assets/images/logoFooter.png';
import { FooterContainer } from './styles';

export function AppVersion() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <FooterContainer>
      <img
        src={Logo}
        alt="Legal Control"
        style={{
          width: isSmallScreen ? '6rem' : '7rem',
          height: isSmallScreen ? '2rem' : '2rem',
          objectFit: 'contain',
        }}
      />
      <div className="version">
        <span>Versão: 1.0.0 Copyright © Legal Control.</span>
        <span>Todos os direitos reservados.</span>
      </div>
    </FooterContainer>
  );
}
